import { useAuth } from "../Auth/Auth";
import { Link, LinkProps } from "react-router-dom";
import { Button } from "antd";

interface Props extends LinkProps {
  functioncode?: string;
  authority?: string;
  showtext?: boolean;
}

export const AuthorityLink = (props: Props) => {
  const { user } = useAuth();

  let authorityOk = false;
  const href = props.to.toString() + "/";
  if (user.userAuthoritys != null) {
    user.userAuthoritys.forEach((element) => {
      if (
        (props.functioncode != null &&
          element.functionCode === props.functioncode) ||
        (props.functioncode == null &&
          element.appURL.length > 0 &&
          href.indexOf(element.appURL + "/") !== -1)
      ) {
        if (
          (props.authority != null && element.authority >= props.authority) ||
          (props.authority == null && element.authority >= "2")
        ) {
          authorityOk = true;
        }
        return;
      }
    });
  }

  if (!authorityOk) {
    if (
      (props.functioncode != null && props.functioncode === "FU-30") ||
      (props.functioncode == null && href.indexOf("/ScoringResultView/") !== -1)
    ) {
      if (user.browsePastFlag === "1") {
        authorityOk = true;
      }
    } else if (
      (props.functioncode != null && props.functioncode === "FU-49") ||
      (props.functioncode == null && href.indexOf("/ScoringUpdate/") !== -1)
    ) {
      if (user.superUpdateFlag === "1") {
        authorityOk = true;
      }
    } else if (
      (props.functioncode != null && props.functioncode === "FU-47") ||
      (props.functioncode == null && href.indexOf("/ScoringConfirm/") !== -1)
    ) {
      if (user.superUpdateFlag === "1") {
        authorityOk = true;
      }
    }
  }

  if (!authorityOk) {
    if (props.showtext) {
      return <>{props.children}</>;
    } else {
      return (
        <Button type="link" disabled={true} size="small">
          {props.children}
        </Button>
      );
    }
  } else {
    return <Link {...props}>{props.children}</Link>;
  }
};
